import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import client from "../../api/client";
import { useMyCompany } from "../../api/useMyCompany";
import { brandOf } from "../payroll/reportBrand";

const toDataUrl = async (path) => {
  const res = await client.get(path.replace(/^\/api/, ""), { responseType: "blob" });
  return await new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = () => resolve(null);
    reader.readAsDataURL(res.data);
  });
};

// شعار الفرع (أو أي ملف) كـ data-url للحقن في التقرير؛ يُرجع null عند الفشل.
export const logoDataUrl = async (path) => {
  if (!path) return null;
  try { return await toDataUrl(path); } catch { return null; }
};

// هوية الشركة (شعار + اسم) جاهزة للحقن في التقارير المطبوعة.
export const useReportBrand = () => {
  const { i18n } = useTranslation();
  const company = useMyCompany();
  const [brand, setBrand] = useState(null);

  const build = useCallback(async () => {
    if (!company) return;
    try {
      setBrand(await brandOf(company, i18n.language, toDataUrl));
    } catch {
      setBrand(await brandOf({ ...company, logo_url: null }, i18n.language, toDataUrl));
    }
  }, [company, i18n.language]);

  useEffect(() => {
    build();
  }, [build]);

  return brand;
};
